'use client';

import { c as _c } from "react/compiler-runtime";
import { type Factiii } from '@shared/all/domains/factiiis';
import { Users } from 'lucide-react';
import { allRequirementOptions } from '../../utils/requirementOptions';
import Avatar from '../common/Avatar';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
const getRequirementLabel = (requirement: string): string => {
  const reqInfo = allRequirementOptions.find(opt => opt.value === requirement);
  return reqInfo?.label || requirement;
};
type Props = {
  closeHandler: () => void;
  allFactiiis: Factiii[];
  currentFactiii: Factiii;
  onFactiiiSelect: (factiiiId: number) => void;
};
export const FactiiiSelectorModal = t0 => {
  const $ = _c(29);
  const {
    closeHandler,
    allFactiiis,
    currentFactiii,
    onFactiiiSelect
  } = t0;
  let t1;
  if ($[0] !== closeHandler || $[1] !== onFactiiiSelect) {
    t1 = factiiiId => {
      onFactiiiSelect(factiiiId);
      closeHandler();
    };
    $[0] = closeHandler;
    $[1] = onFactiiiSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleFactiiiSelect = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-2"><Users className="size-5 text-primary" /><span className="text-textPrimary">Select Factiii</span></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== closeHandler) {
    t3 = <ModalHeader closeHandler={closeHandler}>{t2}</ModalHeader>;
    $[4] = closeHandler;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = allFactiiis.length !== 1 ? "s" : "";
  let t5;
  if ($[6] !== allFactiiis.length || $[7] !== t4) {
    t5 = <div className="text-sm text-textPrimary">Choose from{" "}<strong>{allFactiiis.length} factiii{t4}</strong>{" "}available to switch to it. Note that posts are shown for all factiiis regardless of which is active.</div>;
    $[6] = allFactiiis.length;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mt-2 text-sm text-textSecondary">Click on any factiii below to switch to it.</div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <div className="rounded-lg border border-ds-border-standard bg-background-secondary p-4">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h4 className="text-sm font-semibold text-textPrimary">Available factiiis:</h4>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== allFactiiis || $[14] !== currentFactiii || $[15] !== handleFactiiiSelect) {
    let t10;
    if ($[17] !== currentFactiii || $[18] !== handleFactiiiSelect) {
      t10 = factiii => <button key={factiii.id} onClick={() => handleFactiiiSelect(factiii.id)} className={`flex w-full items-center gap-3 rounded-lg border p-3 transition-all ${factiii.id === currentFactiii.id ? "border-primary bg-primary/5" : "border-ds-border-standard bg-background-secondary"}`}><Avatar size={40} className={`${factiii.id === currentFactiii.id ? "ring-2 ring-primary" : ""}`} spaceAvatarKey={factiii.avatarKey} /><div className="min-w-0 flex-1 text-left"><div className="flex items-center gap-2"><div className="font-emphasis text-textPrimary">{factiii.name}</div>{factiii.id === currentFactiii.id && <span className="rounded-full bg-primary px-2 py-1 text-xs font-emphasis text-white">Current</span>}</div><div className="text-sm text-textSecondary">by @{factiii.username}{factiii.spaceSlug && <span className="ml-1">in /{factiii.spaceSlug}</span>}</div>{factiii.description && <div className="mt-1 text-sm text-textSecondary/70">{factiii.description}</div>}{factiii.requirements.length > 0 && <div className="mt-1 flex flex-wrap gap-1">{factiii.requirements.map(_temp)}</div>}</div></button>;
      $[17] = currentFactiii;
      $[18] = handleFactiiiSelect;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    t9 = allFactiiis.map(t10);
    $[13] = allFactiiis;
    $[14] = currentFactiii;
    $[15] = handleFactiiiSelect;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className="space-y-3">{t8}<div className="space-y-2">{t9}</div></div>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <ModalContent><div className="space-y-4">{t7}{t10}</div></ModalContent>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== closeHandler || $[26] !== t11 || $[27] !== t3) {
    t12 = <Modal closeHandler={closeHandler}>{t3}{t11}</Modal>;
    $[25] = closeHandler;
    $[26] = t11;
    $[27] = t3;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp(req) {
  return <span key={req} className="rounded-full bg-background-secondary px-2 py-1 text-xs text-textSecondary">{getRequirementLabel(req)}</span>;
}